var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 50",
    width: 50,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#61DAFB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,5 C30,5 10,25 10,25 C10,25 30,45 50,45 C70,45 90,25 90,25 C90,25 70,5 50,5 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,25 50,15 55,25",
    fill: "none",
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40,25 45,35 50,25",
    fill: "none",
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,25 55,35 60,25",
    fill: "none",
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 5,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eec708418e03fa829b8298712cc43421.svg";
export { ForwardRef as ReactComponent };